import styles from './AppFootnote.module.scss';

const AppFootnote = ({ content }: any) => {
    return (
        <div className={styles.container}>
            {content.FootnoteTitle.value && (
                <h4 className={styles.title}>{content.FootnoteTitle.value}</h4>
            )}
            <div
                className={styles.content}
                dangerouslySetInnerHTML={{
                    __html: content.FootnoteContent.value,
                }}
            ></div>
        </div>
    );
};

export default AppFootnote;
